import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { SanitizedField } from 'models/field';
import type { RootState } from 'reducers/types';
import {
  isCashfreeOfferSelected,
  isLulu,
  isLuluOfferSelected,
} from 'selectors/entities/offers/offers';
import { useTranslations } from 'utils/translations/useTranslations';

import { TextInputField } from '../TextInputField/TextInputField';

type Props = ConnectedProps<typeof connector> & {
  field: SanitizedField<string>;
  handleBlur: (name: string) => void;
  handleChange: (name: string, value: string) => void;
};

export const SenderAddressInputFieldComponent = ({
  field,
  handleBlur,
  handleChange,
  isLulu,
  isLuluOfferSelected,
  isCashfreeOfferSelected,
}: Props) => {
  const i18n = useTranslations();

  let fieldValue: SanitizedField<string> | null = null;
  if (isLulu || isLuluOfferSelected || isCashfreeOfferSelected) {
    fieldValue = {
      ...field,
      hint: i18n.t('senderInformation.address.india.hint'),
    };
  } else {
    fieldValue = field;
  }

  return (
    <TextInputField
      field={fieldValue}
      handleBlur={handleBlur}
      handleChange={handleChange}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isLulu: isLulu(state),
  isLuluOfferSelected: isLuluOfferSelected(state),
  isCashfreeOfferSelected: isCashfreeOfferSelected(state),
});

const connector = connect(mapStateToProps);

const SenderAddressInputField = connector(SenderAddressInputFieldComponent);

export { SenderAddressInputField };
